module.exports = __webpack_public_path__ + "static/media/couple-good-relationship-healhty-life-svgrepo-com.96acd3ce.svg";